export default "__VITE_ASSET__M5QCHG5Q__"